<template>
  <div class="uniform">
    <div v-if="checkList.length != 0">
      <div v-for="(list, index) in orderData" :key="index">
        <div class="order">
          <div class="flex child">
            <van-image round width="44px" height="44px" :src="list.childData.avatar" class="avatar-1 mr-10" />
            <div class="item-1-1 flex1">
              <div class="name">{{ list.childData.name }}</div>
              <div class="sub-name pt-3">{{ list.childData.class_name }}</div>
            </div>
          </div>
          <van-divider />
          <div class="mb-20" v-for="(item, index) in list.children" :key="index">
            <div class="flex">
              <span class="relative">
                <img :src="item.img" class="img72 mr-10" />
                <span class="labelSuit" v-if="item.bundle_items && item.bundle_items.length > 0">套装</span>
              </span>
              <div class="item-1-1 flex1">
                <div class="name">{{ item.title }} <span class="presale" v-if="item.presale == 1">预售</span></div>
                <div class="sub-name pt-3" v-if="item.bundle_items && item.bundle_items.length > 0">{{ item.exchange_flag ? item.exchange_detail.original_attr.attr2 : item.attr2 }} / {{ $t("uniform.bundle_items_count", { x: getBundleNum(item.bundle_items) }) }}</div>
                <div class="sub-name pt-3" v-else>{{ item.exchange_flag ? item.exchange_detail.original_attr.attr1 : item.attr1 }} / {{ item.exchange_flag ? item.exchange_detail.original_attr.attr2 : item.attr2 }}</div>
                <div class="flex mt-10">
                  <div class="flex1 name">¥ {{ item.unit_price }}</div>
                  <div class="color6 font12">x{{ item.num }}</div>
                </div>
                <div class="uniformStatus" v-if="item.is_bundle_main == 0">
                  <!-- exchange_flag 优先 -->
                  <div class="font12 flex align color3" v-if="item.exchange_flag" @click="showHistory(list, item)">
                    <span class="flex1">
                      <span :class="[getExchangeClass(item), 'ml-5']">{{ getExchangeText(item) }}</span>
                      <span class="color6 font12 ml-10" v-if="[1, 2].includes(item.exchange_flag) && item.exchange_detail">更换为：{{ item.exchange_detail.exchange_attr.attr1 }} / {{ item.exchange_detail.exchange_attr.attr2 }}</span>
                    </span>
                    <van-icon name="arrow" color="#969799" size="12" class="ml-5" />
                  </div>
                  <!-- status 状态 -->
                  <div class="font12 flex align color3" :class="getStatusClass(item)" v-else-if="item.status" @click="showHistory(list, item)">
                    <van-icon :name="getStatusIcon(item)" size="14" />
                    <span class="flex1 ml-5">
                      <span> {{ getStatusText(item) }}</span>
                      <span class="color6 font12 ml-10" v-if="[41, 45, 50].includes(item.status)">退款 ¥{{ item.total_price }}</span>
                    </span>
                    <van-icon name="arrow" color="#969799" size="12" class="ml-5" />
                  </div>
                </div>
                
              </div>
            </div>
            <div class="suitDetails" v-if="item.bundle_items && item.bundle_items.length > 0">
              <div class="flex align-items pb-12" v-for="(bundleItem, index) in item.bundle_items" :key="index">
                <img :src="bundleItem.img" alt="" class="img44" />
                <div class="ml-8 flex1">
                  <div class="color3 font12">{{ bundleItem.title }}</div>
                  <div class="color6 font11 mt-5">{{ bundleItem.exchange_flag ? bundleItem.exchange_detail.original_attr.attr1 : bundleItem.attr1 }} / {{ bundleItem.exchange_flag ? bundleItem.exchange_detail.original_attr.attr2 : bundleItem.attr2 }}</div>
                </div>
                <div class="text-right" @click="showHistory(list, bundleItem, 'bundle')">
                  <div class="font11" :class="getExchangeClass(bundleItem)" v-if="bundleItem.exchange_flag">{{ getExchangeText(bundleItem) }}</div>
                  <div class="font11" :class="getStatusClass(bundleItem)" v-else>{{ getStatusText(bundleItem) }}</div>
                  <div class="color6 font11 ml-10 mt-5" v-if="[41, 45, 50].includes(bundleItem.status)">退款 ¥{{ bundleItem.unit_price }}</div>
                  <div class="color6 font11 ml-10 mt-5" v-if="[1, 2].includes(bundleItem.exchange_flag)">更换为：{{ bundleItem.exchange_detail.exchange_attr.attr2 }}</div>
                </div>
                <van-icon name="arrow" color="#969799" size="12" class="ml-5" />
              </div>
            </div>
            <div class="text-right mt-10" v-if="schoolType != 'BJ_DS' && schoolType != 'BJ_QFF' && schoolType != 'BJ_SLT'">
              <!-- <van-button type="default" v-if="(item.status == 30 || item.status == 40) && item.exchange_flag == 0" class="mr-10" round size="small" @click="replaceOrder(item)">申请换货</van-button> -->
              <van-button type="default" round size="small" v-if="item.status == 20" @click="cancelOrder(list)">{{ $t("uniform.Cancel_order") }}</van-button>
            </div>
          </div>
          <van-divider />
          <div class="text-right">
            <span class="font12 color6 mr-15">{{ $t("uniform.Subtotal", { x: list.product_count }) }}</span>
            <span class="font12 color6">{{ $t("uniform.Total") }}</span> <span class="color3 font12 fontWeight">¥ </span><span class="title">{{ list.order_amount }}</span>
          </div>
        </div>
      </div>
      <div class="order mb-50" :class="schoolType != 'BJ_DS' && schoolType != 'BJ_QFF' && schoolType != 'BJ_SLT' ? 'mb-60' : ''" v-if="orderData.length != 0">
        <div class="title mb-15">{{ $t("uniform.Order_Information") }}</div>
        <div class="flex font13 mb-10">
          <div class="flex1 color6">{{ $t("uniform.Order_NO") }}</div>
          <div class="color3">{{ orderDataList.order_id }}</div>
        </div>
        <div class="flex font13 mb-10">
          <div class="flex1 color6">{{ $t("uniform.Transaction_Time") }}</div>
          <div class="color3">{{ orderDataList.order_date }}</div>
        </div>
        <div class="flex font13 mb-10">
          <div class="flex1 color6">商品数量</div>
          <div class="color3">{{ orderDataList.product_count }}</div>
        </div>
        <div class="flex font13 mb-10">
          <div class="flex1 color6">实付款</div>
          <div class="color3">￥{{ orderDataList.order_amount }}</div>
        </div>
        <div class="flex font13 mb-10" v-if="orderDataList.refund_total_amount != 0">
          <div class="flex1 color6">已退款</div>
          <div class="color3">￥{{ orderDataList.refund_total_amount }}</div>
        </div>
        <div class="flex font13 mb-10">
          <div class="flex1 color6">{{ $t("uniform.Payment_Method") }}</div>
          <div class="color3">{{ $t("uniform.Wechat_Pay") }}</div>
        </div>
      </div>
      <van-goods-action>
        <div class="bto">
          <div class="color3 font14 text-center" v-if="orderDataList.contact_school">
            <router-link to="/message"
              ><van-icon name="chat-o" color="#323233" size="20" /> <span class="ml-5 color3">{{ $t("router.contactCampus") }}</span></router-link
            >
          </div>
          <!-- <div>
            <van-button type="default" round size="small" @click="cancelOrder(orderData[0])">{{ $t("uniform.Cancel_order") }}</van-button>
          </div> -->
        </div>
      </van-goods-action>
    </div>
    <van-action-sheet v-model="cancelShow" :title="$t('uniform.Cancel_order')">
      <div class="content" v-if="cancelData.children">
        <div v-if="!isNext">
          <div class="flex mb-20" v-for="(item, index) in cancelData.children" :key="index">
            <van-checkbox v-if="item.disabled" :disabled="item.disabled"><img :src="item.img" alt="" class="img72 mr-10" /></van-checkbox>
            <van-checkbox v-model="item.checked" v-else>
              <img :src="item.img" alt="" class="img72 mr-10" />
            </van-checkbox>
            <div class="item-1-1 flex1">
              <div class="name">{{ item.title }}</div>
              <div class="sub-name pt-3">{{ item.attr1 }} ｜ {{ item.attr2 }}</div>
              <div class="flex mt-10">
                <div class="flex1 name">¥ {{ item.unit_price }}</div>
                <div class="color6 font14">× {{ item.num }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <van-radio-group v-model="options">
            <van-cell-group>
              <van-cell v-for="(item, index) in checkList" clickable :key="index" :title="item.title" class="padding">
                <template #right-icon>
                  <van-radio :name="item.id" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
          <div class="mt-10 mb-10 color3 font14">{{ $t("notice.memo") }}</div>
          <van-field v-model="reason" rows="2" autosize type="textarea" class="textareaVal" :placeholder="$t('notice.please_memo')" show-word-limit />
        </div>
        <van-goods-action>
          <van-goods-action-button v-if="!isNext" color="#4D88D2" type="warning" :text="$t('uniform.Next_Step')" @click="next()" />
          <van-goods-action-button v-else color="#4D88D2" type="warning" :text="$t('global.submit')" @click="clearOrder()" />
        </van-goods-action>
      </div>
    </van-action-sheet>
    <van-action-sheet v-model="replaceShow" title="申请换货">
      <div class="content">
        <!-- 套装换货：套装商品列表 -->
        <div class="exchange-section" v-if="isBundleExchange && bundleItemsExchange.length > 0">
          <div class="section-title font16">换货商品</div>
          <!-- 外层遍历每个套装 -->
          <div v-for="(group, groupIndex) in bundleItemsExchange" :key="groupIndex" class="mb-20">
            <div class="bundle-exchange-item">
              <div class="exchange-goods-info">
                <div class="exchange-goods-title">{{ replaceData.title }}</div>
                <div class="exchange-goods-spec">
                  <span class="tagBlue">{{ replaceData.attr1 }}</span> {{ replaceData.attr2 }} | 内含{{ group.length }}件单品
                </div>
                <div class="flex">
                  <span class="flex1 color3 font14">￥{{ replaceData.unit_price }}</span>
                  <span class="color6 font14">x{{ replaceData.num }}</span>
                </div>
              </div>
            </div>
            <!-- 内层遍历套装内的每个商品 -->
            <div class="bundle-exchange-list">
              <div v-for="(bundleItem, index) in group" :key="bundleItem.id">
                <div class="bundle-item-header" @click="toggleBundleItem(groupIndex, index)" :class="{ 'bundle-item-disabled': bundleItem.disabled }">
                  <van-checkbox :value="bundleItem.selected" :disabled="bundleItem.disabled" />
                  <img :src="bundleItem.img" class="bundle-item-img" />
                  <div class="bundle-item-info">
                    <div class="bundle-item-title">{{ bundleItem.title }}</div>
                    <div class="bundle-item-spec">{{ bundleItem.attr1 }} / {{ bundleItem.attr2 }}</div>
                    <div class="exchange-tip" v-if="bundleItem.colorNum && bundleItem.sizeNum">更换为：{{ bundleItem.attr1 }} / {{ bundleItem.sizeItem[bundleItem.sizeNum] ? bundleItem.sizeItem[bundleItem.sizeNum].title : bundleItem.sizeNum }} / x{{ bundleItem.exchangeNum }}</div>
                  </div>
                  <div class="bundle-item-status" v-if="bundleItem.disabled">
                    <span class="status-tag status-disabled">不可换货</span>
                  </div>
                </div>

                <!-- 套装单件商品的收货状态和尺码选择 -->
                <div class="bundle-item-options" v-if="bundleItem.selected">
                  <!-- 数量选择器（当 num > 1 时显示） -->
                  <div class="quantity-selector mb-15" v-if="bundleItem.num > 1">
                    <span class="section-title">换货数量</span>
                    <van-stepper class="mt-5" v-model="bundleItem.exchangeNum" :min="1" :max="bundleItem.num" integer />
                  </div>

                  <div class="option-row" v-if="Object.keys(bundleItem.sizeItem).length > 0">
                    <span class="section-title">更换尺码</span>
                    <span class="option-tags">
                      <span
                        v-for="(size, key) in bundleItem.sizeItem"
                        :key="key"
                        class="option-tag"
                        :class="{
                          'option-tag-selected': key === bundleItem.sizeNum,
                        }"
                        @click="!size.disabled && bundleSizeClick(bundleItem, groupIndex, index, key)"
                      >
                        {{ size.title }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <!-- 单品换货 -->
          <div class="exchange-section">
            <div class="section-title font16">换货商品</div>
            <!-- 商品信息 -->
            <div class="single-item-header">
              <img :src="singleItem.img" class="single-item-img" />
              <div class="single-item-info">
                <div class="single-item-title">{{ singleItem.title }}</div>
                <div class="single-item-spec">{{ singleItem.attr1 }} / {{ singleItem.attr2 }} / x{{ singleItem.num }}</div>
                <div class="exchange-tip" v-if="colorNum && sizeNum && colorItem[colorNum] && sizeItem[sizeNum]">更换为：{{ colorItem[colorNum].title }} / {{ sizeItem[sizeNum].title }} / x{{ singleItem.exchangeNum }}</div>
              </div>
              <div class="single-item-price color3 font14">￥{{ singleItem.unit_price }}</div>
            </div>

            <!-- 数量选择器（当 num > 1 时显示） -->
            <div class="quantity-selector mb-15 mt-15" v-if="singleItem.num > 1">
              <span class="section-title">换货数量</span>
              <van-stepper class="mt-5" v-model="singleItem.exchangeNum" :min="1" :max="singleItem.num" integer />
            </div>

            <!-- 颜色选择 -->
            <div class="option-row" v-if="Object.keys(colorItem).length > 0">
              <span class="section-title">更换颜色</span>
              <span class="option-tags">
                <span v-for="(color, key) in colorItem" :key="key">
                  <span v-if="!color.disabled" class="option-tag" :class="{ 'option-tag-selected': key == colorNum }" @click="colorClick(key)">
                    {{ color.title }}
                  </span>
                  <span v-else class="option-tag disabledTag">{{ color.title }}</span>
                </span>
              </span>
            </div>

            <!-- 尺码选择 -->
            <div class="option-row" v-if="Object.keys(sizeItem).length > 0">
              <span class="section-title">更换尺码</span>
              <span class="option-tags">
                <span v-for="(size, key) in sizeItem" :key="key">
                  <span v-if="!size.disabled" class="option-tag" :class="{ 'option-tag-selected': key == sizeNum }" @click="sizeClick(key)">
                    {{ size.title }} <span class="NoStock" v-if="currentStock == 0 && key == sizeNum">{{ $t("uniform.Out_stock") }}</span>
                  </span>
                  <span v-else class="option-tag disabledTag">{{ size.title }}</span>
                </span>
              </span>
            </div>
          </div>
        </div>
        <!-- 补充说明 -->
        <div class="exchange-section">
          <div class="section-title">补充说明</div>
          <van-field v-model="exchangeNote" rows="2" autosize type="textarea" class="textareaVal" placeholder="请输入补充说明（选填）" show-word-limit />
        </div>
        <!-- 提交按钮 -->
        <van-goods-action v-if="!isBundleExchange && currentStock == 0 && sizeNum != '' && colorNum != ''" class="p10">
          <van-goods-action-button color="#4D88D2" type="warning" :text="$t('uniform.Out_stock')" disabled />
        </van-goods-action>
        <van-goods-action v-else>
          <van-goods-action-button color="#4D88D2" type="warning" :text="'确认换货'" @click="submitExchangeApply()" />
        </van-goods-action>
      </div>
    </van-action-sheet>
    <van-action-sheet v-model="historyItemShow" :title="historyItem.title || '订单记录'">
      <div class="order history-popup">
        <!-- 商品信息头部 -->
        <div class="history-header" v-if="historyList.product">
          <div class="flex">
            <img :src="historyItem.img" class="img72 mr-10" />
            <div class="flex1">
              <div class="name flex">
                <span class="flex1">{{ historyItem.title }}</span>
                <div v-if="!historyItem.issuit">¥{{ historyList.product.order_unit_price }}</div>
                <div v-else>
                  <div>
                    <span class="color6 font11">套装折后 </span><span class="color3 font14 fontWeight">¥{{ historyList.product.order_unit_price }}</span>
                  </div>
                  <div class="color6 font11 mt-5">单品原价 ¥{{ historyList.product.unit_price }}</div>
                </div>
              </div>
              <div class="sub-name pt-5 flex align">
                <span class="flex1">{{ historyItem.attr1 }} / {{ historyItem.attr2 }}</span> <span class="text-right">x{{ historyItem.num }}</span>
              </div>
            </div>
          </div>
          <div class="flex mt-10">
            <div class="flex1"></div>
          </div>
        </div>

        <!-- 状态时间线 -->
        <div class="history-timeline mt-16" v-if="historyList.list">
          <div class="timeline-item" v-for="(record, idx) in historyList.list" :key="idx" :class="idx === 0 ? (record.type == 'refund' ? 'red' : record.type == 'send' ? 'blue' : '') : ''">
            <span class="dashed" v-if="idx + 1 != historyList.list.length"></span>
            <div class="timeline-dot"></div>
            <div class="timeline-content flex1">
              <div class="flex align">
                <span class="font14 msg fontWeight">{{ record.msg }}</span>
                <span class="font12 date ml-10" v-if="record.date">{{ record.date }}</span>
              </div>
              <div class="flex mt-5" v-if="record.type == 'refund'">
                <span class="font12 color6">退款：¥{{ historyList.product.order_unit_price }}</span>
              </div>
              <div class="flex mt-5" v-if="record.type == 'exchange'">
                <span class="font12 color6">更换为：{{ record.exchangeAttr2Title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import Vue from "vue";
import { NoticeBar, ActionSheet, Empty, Toast, Icon, GoodsAction, GoodsActionIcon, GoodsActionButton, Sku, Divider, Swipe, SwipeItem, RadioGroup, Radio, Stepper } from "vant";
import { orderDetail, clearOrderGoods, getExchangeSku, submitExchange, exchangeBundle, productInvoiceItemLogs } from "@/api/uniform";
import { childList } from "@/api/child";
import store from "../store";

Vue.use(ActionSheet);
Vue.use(NoticeBar);
Vue.use(Empty);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
Vue.use(Divider);
Vue.use(Sku);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Stepper);
export default {
  name: "uniform",

  data() {
    return {
      orderData: [],
      cancelData: {},
      cancelShow: false,
      checked: [],
      child_id: "",
      childData: [],
      checkList: [],
      showBtn: false,
      isNext: false,
      options: [],
      reason: "",
      childrenList: [],
      schoolType: "",
      // 换货相关
      replaceShow: false,
      exchangeSkuData: {},
      replaceData: {}, // 当前换货商品数据
      exchangeReasons: [], // 换货原因列表
      colorItem: {}, // 颜色选项（单品模式）
      sizeItem: {}, // 尺码选项（单品模式）
      singleItem: {}, // 单品换货数据（单对象）
      colorNum: "", // 选中的颜色（单品模式）
      sizeNum: "", // 选中的尺码（单品模式）
      currentStock: 0, // 当前库存
      exchangeNote: "", // 补充说明
      exchangeOrderId: "", // 换货订单ID
      // 套装换货相关
      isBundleExchange: false, // 是否为套装换货模式
      bundleItemsExchange: [], // 套装商品列表（带选中状态和规格选择）
      bundleSelectedIds: [], // 套装中选中的商品ID
      orderDataList: {},
      historyItemShow: false,
      historyItem: {},
      historyList: {},
    };
  },
  beforeCreate() {
    // document.querySelector("body").setAttribute("style", "background-color:#fff;");
  },
  mounted() {
    let schoolType = store.getters.wxState || "ds";
    document.title = schoolType == "ds" ? this.$t("router.uniform") : this.$t("router.Purchase");
  },
  created() {
    childList().then((res) => {
      this.childrenList = res.data;
      this.schoolType = res.data[0].schoolid;
      this.order_id = this.$route.params.id || "";
      orderDetail({ order_id: this.order_id }).then((res) => {
        this.orderDataList = res.data;
        this.checkList = res.data.refund_reason;
        this.exchangeReasons = res.data.change_reason;
        res.data.list.forEach((items) => {
          // 处理每个订单项
          items.childData = this.childrenList.find((item) => item.id == items.child_id);
        });
        this.orderData = res.data.list;
        console.log(this.orderData);
      });
    });
  },
  methods: {
    getStatusText(item) {
      const statusMap = {
        20: this.$t("uniform.waiting_confirmation"),
        30: this.$t("uniform.waiting_distribution"),
        40: this.$t("uniform.Completed"),
        41: this.$t("uniform.waiting_refund"),
        45: this.$t("uniform.Refunding"),
        50: this.$t("uniform.Refunded"),
        89: this.$t("uniform.Transaction_Expired"),
        99: this.$t("uniform.Cancelled"),
      };
      return statusMap[item.status] || "";
    },
    // 获取状态样式类
    getStatusClass(item) {
      const classMap = {
        20: "orange",
        30: "blue",
        40: "green",
        41: "red",
        45: "red",
        50: "red",
        89: "red",
        99: "red",
      };
      return classMap[item.status] || "";
    },

    // 获取状态图标
    getStatusIcon(item) {
      const iconMap = {
        20: "question-o",
        30: "info-o",
        40: "passed",
        41: "warning-o",
        45: "warning-o",
        50: "warning-o",
        89: "warning-o",
        99: "warning-o",
      };
      return iconMap[item.status] || "";
    },
    getExchangeClass(item) {
      if (item.exchange_flag == 1) {
        return "red";
      }
      if (item.exchange_flag == 2) {
        return "green";
      }
      if (item.exchange_flag == 3) {
        return "";
      }
      return "";
    },
    // 换货状态文本
    getExchangeText(item) {
      const map = { 1: "换货中", 2: "换货完成", 3: "取消换货" };
      return map[item.exchange_flag] || "";
    },
    getBundleNum(bundleItems) {
      return bundleItems.length;
    },
    getList() {
      orderDetail({ order_id: this.order_id }).then((res) => {
        this.orderDataList = res.data;
        this.checkList = res.data.refund_reason;
        this.exchangeReasons = res.data.change_reason;
        res.data.list.forEach((items) => {
          items.childData = this.childrenList.find((item) => item.id == items.child_id);
        });
        this.orderData = res.data.list;
      });
    },
    cancelOrder(list) {
      list.children.forEach((item) => {
        this.$set(item, "checked", false);
        item.disabled = true;
        if (item.status == 20) {
          item.disabled = false;
        }
      });
      this.cancelData = list;
      this.isNext = false;
      this.cancelShow = true;
    },
    next() {
      let checked = this.cancelData.children.filter((item) => item.checked);
      if (checked.length == 0) {
        return;
      }
      this.isNext = true;
    },
    clearOrder() {
      let checked = this.cancelData.children
        .filter((item) => item.checked)
        .map((_item) => {
          return _item.id;
        });
      clearOrderGoods({ ids: checked, reason: this.reason, options: this.options }).then(() => {
        this.cancelShow = false;
        this.getList();
        Toast.success(this.$t("ptc.successful"));
      });
    },
    // 打开换货弹窗
    replaceOrder(item) {
      this.replaceData = item;
      this.exchangeOrderId = item.id;
      this.colorNum = item.attr1 || "";
      this.sizeNum = item.attr2 || "";
      this.selectedReason = "";
      this.receiveStatus = 1;
      this.exchangeNote = "";
      this.bundleSelectedIds = [];
      console.log(item);
      getExchangeSku({
        invoice_item_id: item.id,
      }).then((res) => {
        if (res.code == 0) {
          this.exchangeSkuData = res.data;
          const data = res.data;
          const productAttach = data.productAttach || {};

          this.replaceShow = true;

          if (item.bundle_items && item.bundle_items.length > 0) {
            // 套装模式 - 从 bundle_items 获取换货信息
            this.isBundleExchange = true;

            // 将 bundle_items 包装成二维数组（外层是套装组，内层是套装内商品）
            this.bundleItemsExchange = [
              item.bundle_items.map((goodsItem) => {
                const productInfo = productAttach[goodsItem.pid] || {};
                const sizeAttr = productInfo.attr?.size?.item || {};

                // 转换尺码格式
                const sizes = {};
                Object.entries(sizeAttr).forEach(([key, val]) => {
                  sizes[key] = { title: val, disabled: false };
                });

                return {
                  id: goodsItem.id,
                  pid: goodsItem.pid,
                  title: productInfo.title || "",
                  img: productInfo.imgthumb?.all?.[0] || productInfo.img?.all?.[0] || "",
                  attr1: goodsItem.attr1 || "",
                  attr2: goodsItem.attr2 || "",
                  num: goodsItem.num || 1,
                  status: goodsItem.status,
                  exchange_flag: goodsItem.exchange_flag,
                  paid: goodsItem.paid,
                  selected: false,
                  exchangeNum: 1,
                  sizeItem: sizes,
                  colorNum: goodsItem.attr1Value || "",
                  sizeNum: "",
                  currentStock: 0,
                  disabled: !([30, 40].includes(goodsItem.status) && goodsItem.exchange_flag == 0),
                };
              }),
            ];
            console.log(this.bundleItemsExchange);
          } else {
            // 单品模式
            this.isBundleExchange = false;

            // 从 replaceData 获取单品换货信息
            const pid = item.pid;
            const productInfo = productAttach[pid] || {};
            const colorAttr = productInfo.attr?.color?.item || {};
            const sizeAttr = productInfo.attr?.size?.item || {};

            // 转换颜色格式
            const colors = {};
            Object.entries(colorAttr).forEach(([key, val]) => {
              colors[key] = { title: val, disabled: false };
            });

            // 转换尺码格式
            const sizes = {};
            Object.entries(sizeAttr).forEach(([key, val]) => {
              sizes[key] = { title: val, disabled: false };
            });

            // 构建单品数据（单对象，不是数组）
            this.singleItem = {
              id: item.id,
              pid: pid,
              title: productInfo.title || "",
              img: productInfo.imgthumb?.all?.[0] || productInfo.img?.all?.[0] || "",
              attr1: item.attr1 || "",
              attr2: item.attr2 || "",
              num: item.num || 1,
              status: item.status,
              unit_price: productInfo.unit_price || item.unit_price || 0,
              paid: item.paid,
              exchangeNum: 1,
            };
            // 初始化颜色和尺码选中值
            this.colorItem = colors;
            this.sizeItem = sizes;
            this.colorNum = "";
            this.sizeNum = "";
          }
        }
      });
    },
    // 单品选择颜色
    colorClick(key) {
      console.log(key);
      const productInfo = this.exchangeSkuData.productAttach[this.singleItem.pid];
      const skuData = productInfo?.sku || {};
      // 如果点击的是已选中的颜色，则取消选择
      if (key == this.colorNum) {
        this.colorNum = "";
        for (let size in skuData[key] || {}) {
          this.sizeItem[size].disabled = false;
        }
        return;
      }
      this.colorNum = key;
      for (let sizeKey in productInfo.attr.size.item) {
        if (productInfo.sku[key][sizeKey]) {
          this.sizeItem[sizeKey].disabled = false;
        } else {
          this.sizeItem[sizeKey].disabled = true;
        }
      }
      if (this.sizeNum != "" && this.colorNum != "") {
        this.getStock();
      }
    },
    // 单品选择尺码
    sizeClick(key) {
      const productInfo = this.exchangeSkuData.productAttach[this.singleItem.pid];
      const skuData = productInfo?.sku || {};
      console.log(this.sizeNum);
      console.log(key);
      if (key == this.sizeNum) {
        this.sizeNum = "";
        for (let color in skuData) {
          this.colorItem[color].disabled = false;
        }
        return;
      }
      this.sizeNum = key;

      if (Object.keys(skuData).length > 0) {
        for (let colorKey in skuData) {
          const hasSize = skuData[colorKey] && skuData[colorKey][this.sizeNum];
          this.$set(this.colorItem, colorKey, {
            ...this.colorItem[colorKey],
            disabled: !hasSize,
          });
        }
      }

      if (this.sizeNum != "" && this.colorNum != "") {
        this.getStock();
      }
    },
    // 单品获取库存
    getStock() {
      if (this.colorNum && this.sizeNum) {
        this.currentStock = this.exchangeSkuData.productAttach[this.singleItem.pid].sku[this.colorNum][this.sizeNum].stock;
      }
    },
    // 套装商品选择切换
    toggleBundleItem(groupIndex, index) {
      const item = this.bundleItemsExchange[groupIndex][index];
      if (item.disabled) return;
      item.selected = !item.selected;
      this.updateBundleSelectedIds();
    },
    // 更新选中的套装商品ID
    updateBundleSelectedIds() {
      this.bundleSelectedIds = this.bundleItemsExchange
        .flat()
        .filter((item) => item.selected)
        .map((item) => item.id);
    },
    // 选择套装商品的尺码
    bundleSizeClick(_item, groupIndex, index, key) {
      const targetItem = this.bundleItemsExchange[groupIndex][index];
      if (targetItem.sizeItem[key]?.disabled) return;
      targetItem.sizeNum = key;
    },
    // 提交换货申请
    submitExchangeApply() {
      let sendData = {};
      if (this.isBundleExchange) {
        // 套装换货模式
        if (this.bundleSelectedIds.length === 0) {
          Toast("请选择要换货的商品");
          return;
        }
        const exchange_items = [];
        // 遍历每个套装
        this.bundleItemsExchange.forEach((group) => {
          const selectedInGroup = group.filter((item) => item.selected);
          if (selectedInGroup.length > 0) {
            const bundle_item = selectedInGroup.map((item) => {
              // 获取原SKU和新品SKU的paid
              const productInfo = this.exchangeSkuData.productAttach[item.pid] || {};
              const newSku = productInfo.sku[item.colorNum][item.sizeNum];
              return {
                bundleItemsId: item.id,
                num: item.exchangeNum || 1,
                oldPaid: item.paid,
                newPaid: newSku.paid,
              };
            });
            exchange_items.push(...bundle_item);
          }
        });
        console.log(exchange_items);
        sendData = {
          invoice_item_id: this.exchangeOrderId,
          exchange_items,
          remark: this.exchangeNote,
        };
        exchangeBundle(sendData).then((order) => {
          if (order.code == 0) {
            Toast.success("换货申请提交成功");
            this.replaceShow = false;
            this.refreshOrderDetail();
          }
        });
      } else {
        // 单品换货模式
        if (!this.colorNum || !this.sizeNum) {
          Toast(`请选择商品的颜色和尺码`);
          return;
        }

        const productInfo = this.exchangeSkuData.productAttach[this.singleItem.pid] || {};
        const skuInfo = productInfo.sku?.[this.colorNum]?.[this.sizeNum];

        const exchange_items = {
          num: this.singleItem.exchangeNum || 1,
          oldPaid: this.singleItem.paid,
          newPaid: skuInfo?.paid || this.singleItem.paid,
        };
        sendData = {
          invoice_item_id: this.exchangeOrderId,
          exchange_items,
          remark: this.exchangeNote,
        };
        console.log(sendData);
        submitExchange(sendData).then((order) => {
          if (order.code == 0) {
            Toast.success("换货申请提交成功");
            this.replaceShow = false;
            this.refreshOrderDetail();
          }
        });
      }
    },
    // 刷新订单详情
    refreshOrderDetail() {
      orderDetail({ order_id: this.order_id }).then((res) => {
        this.checkList = res.data.refund_reason;
        res.data.list.forEach((items) => {
          items.childData = this.childrenList.find((item) => item.id == items.child_id);
        });
        this.orderData = res.data.list;
      });
    },
    showHistory(list, item, type) {
      this.historyItem = item;
      productInvoiceItemLogs({ invoice_item_id: item.id, is_bundle: type ? 1 : 0, invoice_id: list.invoice_id }).then((res) => {
        if (res.code == 0) {
          this.historyList = res.data;
          this.historyItem.issuit = type;
          this.historyItemShow = true;
          console.log(this.historyItem);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.presale {
  background: #5cb85c;
  display: inline-block;
  line-height: 4vw;
  float: right;
  border-radius: 50px;
  color: #fff;
  font-size: 3.2vw;
  display: inline-block;
  padding: 2px 4px;
  z-index: 99;
}
.child {
  align-items: center;
  background: linear-gradient(180deg, #e6eeff 0%, #ffffff 100%);
  margin: -12px;
  padding: 12px 12px 0;
  border-radius: 8px 8px 0px 0px;
  margin-bottom: 20px;
}

.relative {
  position: relative;
}

.labelSuit {
  width: 72px;
  height: 16px;
  position: absolute;
  left: 0;
  top: 56px;
  font-size: 12px;
  border-radius: 0 0 8px 8px;
  color: #fff;
  text-align: center;
  line-height: 16px;
  background: rgba(0, 0, 0, 0.5);
}

.uniformStatus {
  padding: 6px 8px;
  background: #f7f8fa;
  border-radius: 4px;
  margin-top: 10px;
}

.order {
  background: #ffffff;
  border-radius: 8px;
  margin: 12px 8px;
  padding: 12px 16px;

  .text-right {
    text-align: right;
  }
}

.mb-50 {
  margin-bottom: 64px;
}

.img72 {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  object-fit: cover;
}

.name {
  font-size: 14px;
  color: #323233;
  font-weight: 500;
}

.sub-name {
  color: #646566;
  font-size: 12px;
}

.orange {
  color: #ed6a0c;
}

.blue {
  color: #4d88d2;
}

.green {
  color: #45a367;
}

.red {
  color: #dc3838;
}

.align {
  align-items: center;
}

.content {
  padding: 16px;
}

.title {
  font-size: 16px;
  color: #323233;
  font-weight: 500;
  // margin-left: 5px;
}

.bto {
  width: 100%;
  padding: 0 16px;
}

.content {
  padding: 16px;
  padding-bottom: 60px;
}

.textareaVal {
  background: #f7f8fa;
  border-radius: 8px;
}

.padding {
  padding: 10px 0;
}

.van-cell::after {
  left: 0;
  right: 0;
}

.mb-60 {
  margin-bottom: 60px;
}

.uniform {
  overflow-y: scroll;
  height: 100vh;
}

.uniform::-webkit-scrollbar {
  display: none;
}

.suitDetails {
  padding: 12px 12px 0;
  background: #f7f8fa;
  border-radius: 8px;
  margin-top: 8px;

  .pb-12 {
    padding-bottom: 12px;
  }

  .img44 {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    object-fit: contain;
  }
}
.font11 {
  font-size: 11px;
  line-height: 11px;
}
// 换货相关样式
.exchange-section {
  margin-bottom: 20px;
}

.font16 {
  font-size: 16px !important;
}

.section-title {
  font-size: 14px;
  color: #323233;
  font-weight: 500;
  margin-bottom: 12px;
}

.goods-status {
  background-color: rgba(242, 243, 245, 1);
  border-radius: 4px;
  padding: 7px 0;
  overflow-wrap: break-word;
  color: rgba(50, 50, 51, 1);
  font-size: 13px;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  border: 1px solid transparent;
}

.goods-check {
  background-color: rgba(77, 136, 210, 0.1);
  border-radius: 4px;
  color: #4d88d2;
  border: 1px solid rgba(77, 136, 210, 1);
}

.reason-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.reason-tag {
  padding: 4px 8px;
  background: #f7f8fa;
  border-radius: 18px;
  font-size: 12px;
  color: #646566;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.3s;
}

.reason-tag.selected {
  background: #e6f0ff;
  color: #4d88d2;
}

.exchange-goods {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
}

.exchange-goods-img {
  width: 72px;
  height: 72px;
  border-radius: 4px;
  object-fit: cover;
  margin-right: 12px;
}

.exchange-goods-info {
  flex: 1;
}

.exchange-goods-title {
  font-size: 14px;
  color: #323233;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  font-weight: bold;
  -webkit-box-orient: vertical;
}

.exchange-goods-spec {
  font-size: 12px;
  color: #969799;

  .tagBlue {
    padding: 0 4px;
    color: #fff;
    background: #4d88d2;
    border-radius: 2px;
  }
}

.exchange-tip {
  display: inline-flex;
  align-items: center;
  padding: 2px 4px;
  background: #fde6e9;
  border-radius: 4px;
  color: #ee0a24;
  font-size: 12px;
}

.exchange-tip span {
  margin-left: 6px;
}

.categoryTitle {
  font-size: 14px;
  color: #323233;
  font-weight: 500;
  margin-bottom: 10px;
  margin-top: 10px;
}

.tagList {
  display: inline-block;
  padding: 8px 16px;
  margin-right: 10px;
  margin-bottom: 10px;
  background: #f7f8fa;
  border-radius: 4px;
  font-size: 13px;
  color: #323233;
  cursor: pointer;
  border: 1px solid transparent;
}

.currentTag {
  background: #4d88d2;
  color: #fff;
  border: 1px solid rgba(77, 136, 210, 1);
}

.disabledTag {
  color: #999 !important;
}

.NoStock {
  right: -10px;
  bottom: 25px;
  background: #ee0a24;
  display: inline-block;
  line-height: 4vw;
  position: absolute;
  border-radius: 50px;
  color: #fff;
  font-size: 3.2vw;
  display: inline-block;
  padding: 2px 4px;
  z-index: 99;
}

// 套装换货样式
.bundle-exchange-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bundle-exchange-item {
  background: #f7f8fa;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 20px;
}

.bundle-item-disabled {
  opacity: 0.6;
}

.bundle-item-selected {
  background: #e6f0ff;
  border: 1px solid #4d88d2;
}

.bundle-item-header {
  display: flex;
  align-items: center;
}

.bundle-item-img {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  object-fit: cover;
  margin-left: 8px;
}

.bundle-item-info {
  flex: 1;
  margin-left: 10px;
  overflow: hidden;
}

.bundle-item-title {
  font-size: 13px;
  color: #323233;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bundle-item-spec {
  font-size: 11px;
  color: #969799;
  margin-top: 4px;
}

.bundle-item-status {
  margin-left: 8px;
}

.status-tag {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 2px;
}

.status-disabled {
  background: #f5f5f5;
  color: #969799;
}

.bundle-item-options {
  margin-top: 12px;
  padding-top: 12px;
  padding-left: 28px;
}

.option-row {
  margin-bottom: 10px;
}

.option-tags {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.option-tag {
  padding: 7px 16px;
  background: #f7f8fa;
  border: 1px solid transparent;
  border-radius: 4px;
  font-size: 12px;
  color: #323233;
  cursor: pointer;
  position: relative;
  display: inline-block;
}

.option-tag-selected {
  background: rgba(77, 136, 210, 0.1);
  border-color: #4d88d2;
  color: #4d88d2;
}

.option-tag-disabled {
  color: #999;
}

// 单品换货样式
.single-item-header {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.single-item-disabled {
  opacity: 0.6;
}

.single-item-img {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  object-fit: cover;
  margin-left: 8px;
}

.single-item-info {
  flex: 1;
  margin-left: 10px;
  overflow: hidden;
}

.single-item-title {
  font-size: 13px;
  color: #323233;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.single-item-spec {
  font-size: 11px;
  color: #969799;
  margin-top: 4px;
}

.fontWeight {
  font-weight: 500;
}

.single-item-price {
  margin-left: 10px;
}

// 订单状态历史弹窗样式
.history-popup {
  padding-bottom: 20px;
  .history-header {
    .name {
      height: 40px;
    }
  }
  .history-timeline {
    .timeline-item {
      display: flex;
      align-items: flex-start;
      padding: 12px 0;
      position: relative;
      .dashed {
        border-left: 1px dashed #c8c9cc;
        position: absolute;
        width: 1px;
        height: 100%;
        left: 5px;
        top: 26px;
      }
      .timeline-dot {
        margin-top: 5px;
        margin-right: 10px;
        z-index: 9;

        &.active::before {
          content: "";
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background: #fff;
          display: block;
          border: 1px solid #dc3838;
        }

        &:not(.active)::before {
          content: "";
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background: #fff;
          display: block;
          border: 1px solid #c8c9cc;
        }
      }

      .timeline-content {
        min-width: 0;

        .fontWeight {
          font-weight: 500;
        }
        .msg {
          color: #323233;
        }
        .date {
          color: #646566;
        }
      }
    }
    .blue {
      .timeline-dot {
        &:not(.active)::before {
          border-color: #4d88d2;
        }
      }
      .msg {
        color: #4d88d2 !important;
      }
      .date {
        color: #4d88d2 !important;
      }
    }
    .red {
      .timeline-dot {
        &:not(.active)::before {
          border-color: #ee0a24;
        }
      }
      .msg {
        color: #ee0a24 !important;
      }
      .date {
        color: #ee0a24 !important;
      }
    }
  }
}
</style>
